import { decode } from '@googlemaps/polyline-codec';
import React from 'react';
import { Polyline } from 'react-leaflet';

// Define default path options
//Change the dashArray for length and spacing of dashes
const DEFAULT_PATH_OPTIONS = { color: 'blue', weight: 4, dashArray: null };
const WALK_PATH_OPTIONS = { ...DEFAULT_PATH_OPTIONS, dashArray: '6 12' };

const normalizePositions = (polyline) => {
  if (!polyline) return null;
  if (typeof polyline === 'string') return decode(polyline);
  if (Array.isArray(polyline)) return polyline;
  return null;
};

const getPathOptionsForTravelMode = (travelMode) => {
  const normalizedMode = (travelMode || '').toString().toUpperCase();
  return normalizedMode === 'WALK' || normalizedMode === 'WALKING'
    ? WALK_PATH_OPTIONS
    : DEFAULT_PATH_OPTIONS;
};

/**
 * Render the active tour route polyline (encoded or raw) or a straight line through stops.
 */
const RouteLayer = ({ activeTourData }) => {
  const legsWithPolylines = Array.isArray(activeTourData?.legs)
    ? activeTourData.legs.filter((leg) => leg?.polyline)
    : [];

  if (legsWithPolylines.length) {
    return legsWithPolylines.map((leg, idx) => {
      const positions = normalizePositions(leg.polyline);
      if (!positions?.length) return null;
      return (
        <Polyline
          key={`leg-${idx}`}
          positions={positions}
          pathOptions={getPathOptionsForTravelMode(leg.travelMode || leg.mode)}
        />
      );
    });
  }

  if (activeTourData?.encodedPolyline) {
    return (
      <Polyline
        positions={decode(activeTourData.encodedPolyline)}
        pathOptions={DEFAULT_PATH_OPTIONS}
      />
    );
  }

  if (activeTourData?.polyline && !activeTourData?.encodedPolyline) {
    return <Polyline positions={activeTourData.polyline} pathOptions={DEFAULT_PATH_OPTIONS} />;
  }

  if (!activeTourData?.polyline && !activeTourData?.encodedPolyline && activeTourData?.stops) {
    return (
      <Polyline
        positions={activeTourData.stops.map((stop) => stop.coordinates)}
        pathOptions={DEFAULT_PATH_OPTIONS}
      />
    );
  }

  return null;
};

export default RouteLayer;
